export const LogoMark = ({ size = 40, className = "" }) => (
  <img
    src="/hv-symbol-gold.png"
    width={size}
    height={Math.round(size / 0.8011)}
    alt=""
    aria-hidden="true"
    className={className}
    draggable="false"
  />
);

const Logo = ({ variant = "nav" }) => {
  if (variant === "nav") {
    return (
      <span className="flex items-center gap-4 whitespace-nowrap" data-testid="brand-logo">
        <LogoMark size={36} />
        <span className="flex flex-col leading-none">
          <span className="whitespace-nowrap font-serif text-[17px] tracking-[0.14em] text-ivory">
            HUDSON <span className="text-gold">&amp;</span> STIR
          </span>
          <span className="mt-2 flex items-center gap-2">
            <span className="h-px w-4 bg-gold/70" aria-hidden="true" />
            <span className="font-sans text-[8px] tracking-[0.5em] text-gold">
              MOBILE BAR
            </span>
            <span className="h-px w-4 bg-gold/70" aria-hidden="true" />
          </span>
        </span>
      </span>
    );
  }
  return (
    <span className="flex flex-col items-center gap-6" data-testid="brand-logo-large">
      <LogoMark size={64} />
      <span className="flex flex-col items-center leading-none">
        <span className="font-serif text-2xl tracking-[0.12em] text-ivory">
          HUDSON <span className="text-gold">&amp;</span> STIR
        </span>
        <span className="mt-4 flex items-center gap-3">
          <span className="h-px w-8 bg-gold/70" aria-hidden="true" />
          <span className="font-sans text-[10px] tracking-[0.55em] text-gold">
            MOBILE BAR
          </span>
          <span className="h-px w-8 bg-gold/70" aria-hidden="true" />
        </span>
      </span>
    </span>
  );
};

export default Logo;
